import { render, staticRenderFns } from "./PaymentMsgModal.vue?vue&type=template&id=532f7568&"
import script from "./PaymentMsgModal.vue?vue&type=script&lang=js&"
export * from "./PaymentMsgModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMsgModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports